import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2, 0),
  },
  inputForm: {
    height: theme.spacing(7),
    marginBottom: theme.spacing(2),
  },
}))

export default useStyles
